module.exports = __webpack_public_path__ + "static/media/AT.31eec967.jpeg";